// extracted by mini-css-extract-plugin
export var aircallIframe = "_ev-3";
export var fabContainer = "_ev-5";
export var fabRinging = "_ev-6";
export var loadingOverlay = "_ev-4";
export var pulse = "_ev-7";
export var widgetContent = "_ev-2";
export var widgetPanel = "_ev-0";
export var widgetPanelExpanded = "_ev-1";